import { createSimpleWrapper } from "../tag/createSimpleWrapper";
export const Container = createSimpleWrapper("div", "container");
